import { InjectionToken } from '@angular/core';

export const WL_CONFIG = new InjectionToken('mydocma-wl-config');

export interface Config {
    apiBaseUrl: string;
}
